var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.623047,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#D0E2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9457 9.24498L11.5923 17.3066L9.37568 14.9383C8.96734 14.5533 8.32568 14.53 7.85901 14.8566C7.40401 15.195 7.27568 15.79 7.55568 16.2683L10.1807 20.5383C10.4373 20.935 10.8807 21.18 11.3823 21.18C11.8607 21.18 12.3157 20.935 12.5723 20.5383C12.9923 19.99 21.0073 10.435 21.0073 10.435C22.0573 9.36165 20.7857 8.41665 19.9457 9.23331V9.24498Z",
    fill: "#01625F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.eee10bce5780b9a0757cc0ea8106ea3e.svg";
export { ForwardRef as ReactComponent };